import React from 'react'
import './Layout.css'
import { Box, Stack } from '@mui/material'

import { Sidenav } from '../../ReuseComponent/SideNav/Sidenav'
import { CustomNavbar } from '../../Components/CustomNavbar/customnabar'

const Layout = ({children, label, showNav=true}) => {
  return (
     <div className="main-layout">
        <Sidenav/>
        <div className='main-body'>
          {showNav && <div style={{position: 'fixed',width:'85%', borderLeft: '1px solid #ccc', zIndex:1000}}>
            <CustomNavbar label={label} />
          </div>}

          <div style={{marginTop: '2rem'}}>
          {children}

          </div>
        </div>

     </div>
     
      
  )
}

export default Layout